import { Pipe, PipeTransform } from '@angular/core';
import { ColumnText } from '@ddt-web/data-service';

@Pipe({ name: 'lastWord' })
export class LastWordPipe implements PipeTransform {
	public transform(value: ColumnText): string {
		const words: string[] = [...value.toString().split(' ')];
		return words[words.length - 1];
	}
}
